import { Link } from 'react-router-dom';
import { ranking, categories } from '@/mocks/home';
import SectionHeading from './SectionHeading';
import ScrollReveal from './ScrollReveal';

export default function Ranking() {
  return (
    <section className="bg-gray-50/50">
      <div className="section-padding">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            index="04"
            eyebrow="人气榜单"
            title="本周人气排行榜"
            subtitle="数据每周更新，看看大家都在追哪些作品。"
          />

          <div className="grid lg:grid-cols-5 gap-10">
            {/* 榜单列表 */}
            <div className="lg:col-span-3">
              <div className="rounded-lg border-2 border-gray-900 bg-white shadow-[4px_4px_0_0_#ff9db8] overflow-hidden">
                {ranking.map((item, i) => (
                  <ScrollReveal key={item.title} delay={i * 40}>
                    <div
                      className={`flex items-center gap-5 px-6 py-4 ${
                        i !== 0 ? 'border-t-2 border-gray-100' : ''
                      }`}
                    >
                      <span
                        className={`font-serif text-2xl font-bold w-10 text-center ${
                          i < 3 ? 'text-pink-500' : 'text-gray-300'
                        }`}
                      >
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-bold text-gray-900 truncate">{item.title}</h3>
                        <p className="text-xs text-gray-400 mt-0.5">{item.category}</p>
                      </div>
                      <div className="hidden sm:block w-32 h-1.5 rounded-full bg-gray-100 overflow-hidden">
                        <div
                          className="h-full bg-pink-400"
                          style={{ width: `${Math.max(30, 100 - i * 8)}%` }}
                        />
                      </div>
                      <span className="text-xs text-gray-400 whitespace-nowrap">{item.heat}</span>
                    </div>
                  </ScrollReveal>
                ))}
              </div>
            </div>

            {/* 分类标签 */}
            <div className="lg:col-span-2">
              <div className="lg:sticky lg:top-24">
                <h3 className="text-sm font-bold text-gray-900 mb-6 flex items-center gap-2">
                  <span className="w-5 h-px bg-pink-500" />
                  全部分类
                </h3>
                <div className="flex flex-wrap gap-3">
                  {categories.map((cat) => (
                    <span
                      key={cat}
                      className="inline-block px-4 py-2 rounded-lg border-2 border-gray-900 bg-white text-sm text-gray-700 shadow-[2px_2px_0_0_#ff9db8] hover:bg-pink-50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat}
                    </span>
                  ))}
                </div>
                <p className="mt-8 text-xs text-gray-400 leading-relaxed">
                  天天漫画涵盖 12 大品类、10万+ 部作品，满足每一位漫迷的阅读口味。
                </p>
                <Link to="/hot-comics" className="mt-8 btn-comic-solid px-6 py-3">
                  了解更多人气排行 <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}